import { UserLogin } from "../models";

export class UserLoginInfo extends UserLogin {
    confirmPassword: string;
}


// WEBPACK FOOTER //
// ./src/app/models/userLoginInfo.ts